'use client'
import React, { useEffect, useMemo, useState } from 'react'
import FilterVentesTypeBien from '../Select/FilterVentesTypeBien'
import FilterVenteDate from '../Select/FilterVenteDate'
import { Prisma } from '@prisma/client'
import FilterVentePrixMax from '../Select/FilterVentePrixMax'
import { useSearchParams } from 'next/navigation'
import FilterVenteId from '../Select/FilterVenteId'
import FilterVentesTribunal from '../Select/FilterVentesTribunal'

type Props = {
    typesBiens: Prisma.VentesTypeGetPayload<{}>[]
    tgis: Prisma.TgiGetPayload<{}>[]
}

const MoreSearch = ({ typesBiens, tgis }: Props) => {

    const searchParams = useSearchParams()
    const params = useMemo(() => new URLSearchParams(searchParams.toString()), [searchParams])

    const [moreCriteria, setMoreCriteria] = useState(false);

    useEffect(() => {
        if (Boolean(params.get('typesBiens') || params.get('startDateVente') || params.get('endDateVente') || params.get('prixMax') || params.get('numero') || params.get('tgi'))) {
            setMoreCriteria(true)
            
        }
    }, [params])

    return (
        <>
            <div className="flex justify-center">
                <button onClick={() => setMoreCriteria(!moreCriteria)} className="bg-transparent underline font-bold hover:bg-zinc-400 rounded-md  mt-2 p-2">
                    {moreCriteria ? 'Moins de critères' : 'Plus de critères'}
                </button>
            </div>
            {moreCriteria && 
            <>
                <div className="flex flex-col w-full lg:flex-row justify-between items-center lg:space-x-4 space-y-4 lg:space-y-0 mt-2">
                    <FilterVentesTribunal tgis={tgis} searchParams={searchParams} />
                    <FilterVentesTypeBien typesBiens={typesBiens} searchParams={searchParams} />
                    <FilterVenteDate searchParams={searchParams} />
                    
                </div>
                <div className="flex flex-col w-full lg:flex-row justify-between items-center lg:space-x-4 lg:space-y-0 mt-4">
                    <FilterVentePrixMax searchParams={searchParams} />
                    <FilterVenteId searchParams={searchParams} />
                    <div className="relative w-full lg:w-1/3"></div>
                </div>
            </>
            }
        </>
    )
}

export default MoreSearch